import script from "./UserDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetail.vue?vue&type=script&setup=true&lang=js"

import "./UserDetail.vue?vue&type=style&index=0&id=f2384438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2384438"]])

export default __exports__